import React from 'react';
import {makeStyles} from '@mui/styles';

const useStyles = makeStyles({
  root: props => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: 1,
    minHeight: '100vh',
    '& .MuiAppBar-root': {
      paddingLeft: '280px !important',
    },
  }),
});

const WebDrawerScreensWrapper = props => {
  //@ts-ignore
  const classes = useStyles();

  return <div className={classes.root}>{props.children}</div>;
};

export default WebDrawerScreensWrapper;
